// Languages offered on the website, in priority order.
export const LANGUAGES = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'ml', label: 'മലയാളം', short: 'മല' },
  { code: 'kn', label: 'ಕನ್ನಡ', short: 'ಕನ್ನ' },
  { code: 'ta', label: 'தமிழ்', short: 'தமி' },
];

export const DEFAULT_LANGUAGE = 'en';

// Fixed words and labels shown on the pages, per language.
// Use them in a component with:  const { t } = useLanguage();  t('ingredients')
// A word missing in a language falls back to English.
// {n} and {lang} are filled in by the page.
export const TRANSLATIONS = {
  en: {
    language: 'Language',
    recipes_eyebrow: 'Recipes',
    recipes_title: 'Mushroom recipes from our kitchen',
    recipes_subtitle: 'Simple, tasty ways to cook Oval Farms mushrooms at home.',
    search_recipes: 'Search recipes',
    no_results: 'No recipes match your search.',
    view_recipe: 'View recipe',
    back_to_recipes: 'All recipes',
    ingredients: 'Ingredients',
    ingredients_count: '{n} ingredients',
    instructions: 'Method',
    utensils: 'Utensils needed',
    cooking_time: 'Cooking time',
    minutes: 'min',
    loading: 'Loading…',
    recipe_not_found: 'Sorry, we could not find this recipe.',
    not_translated: 'This recipe is not available in {lang} yet, so parts are shown in English.',
    more_recipes: 'More recipes',
    order_cta_title: 'Cook it with farm-fresh mushrooms',
    order_cta_text: 'Order fresh oyster mushrooms from Oval Farms, delivered to your door.',
    order_cta_button: 'Order on WhatsApp',
    units: {
      g: 'g', kg: 'kg', ml: 'ml', l: 'litre', tsp: 'tsp', tbsp: 'tbsp', cup: 'cup',
      nos: '', sprig: 'sprig', clove: 'cloves', pinch: 'pinch',
      to_taste: 'to taste', as_needed: 'as needed',
    },
  },

  ml: {
    language: 'ഭാഷ',
    recipes_eyebrow: 'പാചകക്കുറിപ്പുകൾ',
    recipes_title: 'ഞങ്ങളുടെ അടുക്കളയിൽ നിന്നുള്ള കൂൺ വിഭവങ്ങൾ',
    recipes_subtitle: 'ഓവൽ ഫാംസ് കൂൺ വീട്ടിൽ രുചികരമായി പാകം ചെയ്യാനുള്ള എളുപ്പവഴികൾ.',
    search_recipes: 'പാചകക്കുറിപ്പ് തിരയുക',
    no_results: 'തിരഞ്ഞതിനോട് യോജിക്കുന്ന പാചകക്കുറിപ്പുകളൊന്നുമില്ല.',
    view_recipe: 'പാചകക്കുറിപ്പ് കാണുക',
    back_to_recipes: 'എല്ലാ പാചകക്കുറിപ്പുകളും',
    ingredients: 'ചേരുവകൾ',
    ingredients_count: '{n} ചേരുവകൾ',
    instructions: 'തയ്യാറാക്കുന്ന വിധം',
    utensils: 'ആവശ്യമായ പാത്രങ്ങൾ',
    cooking_time: 'പാചക സമയം',
    minutes: 'മിനിറ്റ്',
    loading: 'ലോഡ് ചെയ്യുന്നു…',
    recipe_not_found: 'ക്ഷമിക്കണം, ഈ പാചകക്കുറിപ്പ് കണ്ടെത്താനായില്ല.',
    not_translated: 'ഈ പാചകക്കുറിപ്പ് ഇതുവരെ {lang} ഭാഷയിൽ ലഭ്യമല്ല, ചില ഭാഗങ്ങൾ ഇംഗ്ലീഷിൽ കാണിക്കുന്നു.',
    more_recipes: 'കൂടുതൽ വിഭവങ്ങൾ',
    order_cta_title: 'ഫാം ഫ്രഷ് കൂൺ കൊണ്ട് തയ്യാറാക്കൂ',
    order_cta_text: 'ഓവൽ ഫാംസിൽ നിന്ന് ഫ്രഷ് ചിപ്പിക്കൂൺ ഓർഡർ ചെയ്യൂ, വീട്ടുപടിക്കൽ എത്തിക്കും.',
    order_cta_button: 'വാട്സ്ആപ്പിൽ ഓർഡർ ചെയ്യുക',
    units: {
      g: 'ഗ്രാം', kg: 'കിലോ', ml: 'മി.ലി', l: 'ലിറ്റർ', tsp: 'ടീസ്പൂൺ', tbsp: 'ടേബിൾസ്പൂൺ', cup: 'കപ്പ്',
      nos: 'എണ്ണം', sprig: 'തണ്ട്', clove: 'അല്ലി', pinch: 'നുള്ള്',
      to_taste: 'ആവശ്യത്തിന്', as_needed: 'ആവശ്യത്തിന്',
    },
  },

  kn: {
    language: 'ಭಾಷೆ',
    recipes_eyebrow: 'ಅಡುಗೆ ವಿಧಾನಗಳು',
    recipes_title: 'ನಮ್ಮ ಅಡುಗೆಮನೆಯಿಂದ ಅಣಬೆ ಖಾದ್ಯಗಳು',
    recipes_subtitle: 'ಓವಲ್ ಫಾರ್ಮ್ಸ್ ಅಣಬೆಗಳನ್ನು ಮನೆಯಲ್ಲೇ ರುಚಿಯಾಗಿ ಬೇಯಿಸುವ ಸುಲಭ ವಿಧಾನಗಳು.',
    search_recipes: 'ಅಡುಗೆ ವಿಧಾನ ಹುಡುಕಿ',
    no_results: 'ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಹೊಂದುವ ಅಡುಗೆ ವಿಧಾನಗಳಿಲ್ಲ.',
    view_recipe: 'ವಿಧಾನ ನೋಡಿ',
    back_to_recipes: 'ಎಲ್ಲಾ ಅಡುಗೆ ವಿಧಾನಗಳು',
    ingredients: 'ಬೇಕಾಗುವ ಸಾಮಗ್ರಿಗಳು',
    ingredients_count: '{n} ಸಾಮಗ್ರಿಗಳು',
    instructions: 'ಮಾಡುವ ವಿಧಾನ',
    utensils: 'ಬೇಕಾಗುವ ಪಾತ್ರೆಗಳು',
    cooking_time: 'ಅಡುಗೆ ಸಮಯ',
    minutes: 'ನಿಮಿಷ',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ…',
    recipe_not_found: 'ಕ್ಷಮಿಸಿ, ಈ ಅಡುಗೆ ವಿಧಾನ ಸಿಗಲಿಲ್ಲ.',
    not_translated: 'ಈ ಅಡುಗೆ ವಿಧಾನ ಇನ್ನೂ {lang} ಭಾಷೆಯಲ್ಲಿ ಲಭ್ಯವಿಲ್ಲ, ಕೆಲವು ಭಾಗಗಳನ್ನು ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ತೋರಿಸಲಾಗಿದೆ.',
    more_recipes: 'ಇನ್ನಷ್ಟು ಖಾದ್ಯಗಳು',
    order_cta_title: 'ತಾಜಾ ಅಣಬೆಗಳಿಂದ ಮಾಡಿ ನೋಡಿ',
    order_cta_text: 'ಓವಲ್ ಫಾರ್ಮ್ಸ್‌ನಿಂದ ತಾಜಾ ಸಿಂಪಿ ಅಣಬೆ ಆರ್ಡರ್ ಮಾಡಿ, ಮನೆ ಬಾಗಿಲಿಗೆ ತಲುಪಿಸುತ್ತೇವೆ.',
    order_cta_button: 'ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ಆರ್ಡರ್ ಮಾಡಿ',
    units: {
      g: 'ಗ್ರಾಂ', kg: 'ಕೆಜಿ', ml: 'ಮಿ.ಲೀ', l: 'ಲೀಟರ್', tsp: 'ಟೀ ಚಮಚ', tbsp: 'ಟೇಬಲ್ ಚಮಚ', cup: 'ಕಪ್',
      nos: '', sprig: 'ಕಡ್ಡಿ', clove: 'ಎಸಳು', pinch: 'ಚಿಟಿಕೆ',
      to_taste: 'ರುಚಿಗೆ ತಕ್ಕಷ್ಟು', as_needed: 'ಅಗತ್ಯವಿರುವಷ್ಟು',
    },
  },

  ta: {
    language: 'மொழி',
    recipes_eyebrow: 'சமையல் குறிப்புகள்',
    recipes_title: 'எங்கள் சமையலறையிலிருந்து காளான் உணவுகள்',
    recipes_subtitle: 'ஓவல் ஃபார்ம்ஸ் காளான்களை வீட்டிலேயே சுவையாக சமைக்க எளிய வழிகள்.',
    search_recipes: 'சமையல் குறிப்பைத் தேடுக',
    no_results: 'உங்கள் தேடலுக்கு பொருந்தும் சமையல் குறிப்புகள் இல்லை.',
    view_recipe: 'செய்முறையைப் பார்க்க',
    back_to_recipes: 'அனைத்து சமையல் குறிப்புகள்',
    ingredients: 'தேவையான பொருட்கள்',
    ingredients_count: '{n} பொருட்கள்',
    instructions: 'செய்முறை',
    utensils: 'தேவையான பாத்திரங்கள்',
    cooking_time: 'சமையல் நேரம்',
    minutes: 'நிமிடம்',
    loading: 'ஏற்றுகிறது…',
    recipe_not_found: 'மன்னிக்கவும், இந்த சமையல் குறிப்பு கிடைக்கவில்லை.',
    not_translated: 'இந்த சமையல் குறிப்பு இன்னும் {lang} மொழியில் இல்லை, சில பகுதிகள் ஆங்கிலத்தில் காட்டப்படுகின்றன.',
    more_recipes: 'மேலும் உணவுகள்',
    order_cta_title: 'புதிய காளான்களுடன் சமைத்துப் பாருங்கள்',
    order_cta_text: 'ஓவல் ஃபார்ம்ஸிலிருந்து புதிய சிப்பிக் காளான்களை ஆர்டர் செய்யுங்கள், வீட்டு வாசலுக்கே வரும்.',
    order_cta_button: 'வாட்ஸ்அப்பில் ஆர்டர் செய்யுங்கள்',
    units: {
      g: 'கிராம்', kg: 'கிலோ', ml: 'மி.லி', l: 'லிட்டர்', tsp: 'தேக்கரண்டி', tbsp: 'மேசைக்கரண்டி', cup: 'கப்',
      nos: '', sprig: 'கொத்து', clove: 'பல்', pinch: 'சிட்டிகை',
      to_taste: 'தேவைக்கேற்ப', as_needed: 'தேவையான அளவு',
    },
  },
};
